import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AssetSelectionComponent } from '@features/shopping/asset/selection/asset-selection.component';
import { UserAsset } from '@models/dashboard.model';
import { getCarrier } from '@models/functions.model';
import { ShoppingCartData } from '@models/shopping-cart.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { ActivityManagerService } from '@services/activity/manager/activity-manager.service';
import { ShoppingService } from '@services/shopping/shopping.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ts-activity-14-device-selection',
  imports: [AssetSelectionComponent, TranslationPipe],
  templateUrl: './device-selection.component.html'
})
export class DeviceSelectionComponent implements OnInit, OnDestroy {
  asset: UserAsset | undefined;
  shopping_cart: ShoppingCartData;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private activity_manager_svc: ActivityManagerService,
    private shopping_svc: ShoppingService
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.shopping_svc.getShoppingItems().subscribe({
        next: (res: ShoppingCartData) => {
          this.shopping_cart = res;
        },
        error: (err: HttpErrorResponse) => {}
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  selectAsset(asset: UserAsset): void {
    this.asset = { ...asset, asset_selection_case: 1 };

    this.shopping_svc.sendShoppingItems(this.shoppingCartParam(), true).subscribe({
      next: (res: ShoppingCartData) => {
        this.activity_manager_svc.navigateToNextStep({
          queryParams: {
            deviceId:
              asset?.device?.device_catalog_id ?? asset?.line?.device_catalog_id ?? undefined,
            lineId:
              !asset?.device?.device_catalog_id && !asset?.line?.device_catalog_id
                ? asset?.line?.id
                : undefined
          }
        });
      },
      error: (err: HttpErrorResponse) => {}
    });
  }

  private shoppingCartParam(): ShoppingCartData {
    return {
      ...this.shopping_cart,
      country_id:
        this.asset?.line.country_id ?? this.activity_manager_svc.state().parameter('country')?.id,
      carrier: this.asset?.line && getCarrier(this.asset.line),
      orderTypeId: this.activity_manager_svc.currentOrderTypeId(),
      order_for_person: this.shopping_cart.order_for_person,
      lineId: this.asset?.line.id,
      existing_asset: this.asset!,
      progress_stepper: this.activity_manager_svc
        .state()
        .currentStep(this.activity_manager_svc.state().activeStepIndex())
    };
  }
}
